module.exports = __webpack_public_path__ + "img/ajax.ce960b0d.jpg";